import { useNavigate } from "react-router-dom";

export default function CtaSection() {
  const navigate = useNavigate();
  return (
    <section className="relative w-full overflow-hidden py-14 md:py-16">
      <img
        src="https://readdy.ai/api/search-image?query=%E9%BB%8E%E6%98%8E%E5%B1%B1%E8%B0%B7%E9%9B%BE%E6%B0%94%E4%B8%8E%E8%B5%A4%E7%BA%A2%E6%9C%9D%E9%98%B3%E5%AF%B9%E6%AF%94%EF%BC%8C%E6%9A%97%E9%BB%91%E4%B8%8E%E7%87%8E%E7%81%AB%E7%BA%A2%E5%B1%B1%E6%B0%B4%E6%84%8F%E5%A2%83%E4%B8%AD%E5%9B%BD%E6%B0%B4%E5%A2%A8%E7%94%BB%E9%A3%8E%E6%A0%BC%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%BC%AB%E7%94%BB%E8%83%8C%E6%99%AF&width=1600&height=500&seq=cta-ink-2026&orientation=landscape"
        alt="古风漫画网水墨山林意境"
        className="absolute inset-0 h-full w-full object-cover object-center"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-foreground-950/70"></div>
      <div className="relative z-10 container-x flex flex-col items-center justify-center py-8 text-center">
        <h2 className="max-w-2xl font-heading text-3xl font-bold leading-tight text-background-50 md:text-4xl">
          一部好的古风漫画，值得被好好收藏
        </h2>
        <p className="mt-3 max-w-xl text-sm text-background-200 md:text-base">
          分类清晰、每日更新、追更收藏一步到位。现在就挑一部心仪的国漫，开始你的古风之旅吧。
        </p>
        <div className="mt-6 flex flex-col gap-3 sm:flex-row">
          <button onClick={() => navigate("/category")} className="btn-primary text-base">
            <i className="ri-brush-line mr-1.5"></i>浏览全部分类
          </button>
          <button
            onClick={() => navigate("/contact")}
            className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-background-200 bg-background-50/10 px-6 py-3 text-base font-semibold text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20 cursor-pointer"
          >
            联系我们
          </button>
        </div>
      </div>
    </section>
  );
}